import styled from 'styled-components';

export const Wrapper = styled.div`
  text-align: center;
  padding: 3.5rem 2rem 3rem;
  box-shadow: inset 0px 0px 52px rgba(0, 0, 0, 0.3);
`;



// WEBPACK FOOTER //
// ./src/components/UnfinishedBanner/UnfinishedBannerStyles.js